// extracted by mini-css-extract-plugin
module.exports = {"container":"_3B-ZmMdtdf7nruJkAJf0SL"};